/// <reference types="vite-plugin-pwa/client" />
/**
 * Die App aktuell halten.
 *
 * Als installierte PWA wird diese Seite kaum je neu geladen: man tippt aufs
 * Symbol, das Fenster kommt aus dem Hintergrund zurück, und der Service Worker
 * liefert weiter, was er im Keller hat. Ohne Anstoß bleibt jemand damit
 * beliebig lange auf einer alten Fassung — und wer auf einer Fassung mit einem
 * Fehler festsitzt, kommt aus eigener Kraft nicht heraus.
 *
 * Deshalb fragen wir nach: beim Start, bei jeder Rückkehr in den Vordergrund
 * und im Takt, solange das Fenster sichtbar ist. Findet sich etwas Neues, lädt
 * `autoUpdate` die Seite selbst neu.
 */
import { registerSW } from 'virtual:pwa-register'

/**
 * Wie oft im Vordergrund nachgefragt wird. Der Prüfstand baut mit einem
 * kurzen Takt — sonst dauert ein Lauf fünf Minuten.
 */
const TAKT_MS = Number(import.meta.env.VITE_FASSUNG_TAKT_MS ?? 5 * 60 * 1000)

export function halteAktuell(): void {
  registerSW({
    immediate: true,
    onRegisteredSW(_pfad, registrierung) {
      if (!registrierung) return

      const frage = (): void => {
        // Nur im Vordergrund — im Hintergrund schläft das Fenster ohnehin.
        if (document.visibilityState === 'visible') void registrierung.update()
      }

      setInterval(frage, TAKT_MS)
      document.addEventListener('visibilitychange', frage)
      // Aus dem Seiten-Cache zurück (iOS macht das beim App-Wechsel).
      window.addEventListener('pageshow', frage)
    },
  })
}
